import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  checkReportIdWithName,
  getDashboardType,
  getPathFromDashboard,
} from '@/pages/dashboard/utils/utils';
import { LOG_SYSTEM_TYPE, PAGE_TYPE_PRESET } from '@/pages/dashboard/_config/constant';
import Permission from '@/pages/dashboard/components/NoPermission';
import Loading from '@/pages/dashboard/components/Loadings';
import { useParams, useSelector } from 'umi';
import { getPresetInfo } from '@/pages/dashboard/services/dashboard';
import { embedDashboard } from "@/pages/dashboard/_plugins/preset-sdk";
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import GuideTableau from '@/pages/dashboard/components/UserGuide/Tableau';
import { strToObject } from '@/pages/dashboard/utils/utils';

interface ReportInfoType {
  loading: boolean;
  noReport: boolean,
}

const INIT_REPORT_INFO:ReportInfoType = {
  noReport: false,
  loading: false
};

export default (props: any) => {
  const [reportInfo, setReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const dashboardRef = useRef<any>(null);
  const presetRef = useRef<any>(null);
  const { reportId } = useParams() as any;
  const { currentMenu, currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentMenu, currentGame } = state.dashboard;
    return {
      currentMenu,
      currentGame
    }
  });

  const setState = (params = {}) => {
    setReportInfo({
      ...INIT_REPORT_INFO,
      ...params
    });
  }

  // preset 处理逻辑
  const openPresetReport = () => {
    if (!reportId || !currentGame ) {
      return;
    }
    if (!currentMenu || getDashboardType(currentMenu) !== PAGE_TYPE_PRESET || !checkReportIdWithName(reportId, currentMenu?.name_en)) {
      return;
    }
    dashboardRef.current = currentMenu;
    // const presetId = currentMenu?.[PAGE_URL_KEY[PAGE_TYPE_PRESET]];
    let { preset_id: rawPresetId, preset_id: presetId = '', workspace_id: wordspaceId = '', workspace_region: workspaceRegion = '', team_id: teamId ='', extra_info: extInfo = '' } = currentMenu || {};
    // 如果有额外信息，组装presetId，组装规则<preset_id>;<workspace_id>;<workspace_region>;<team_id>
    if (wordspaceId && workspaceRegion && teamId) {
      presetId = [presetId, wordspaceId, workspaceRegion, teamId].join(';');
    }

    // gameCode
    if (!presetId) {
      presetRef.current && presetRef.current?.unmount();
      setState({
        noReport: true
      });
      return;
    }
    setState({
      loading: true
    });
    const { game_code: gameCode } = currentGame;
    getPresetInfo(`${gameCode}/${presetId}`).then(presetInfo => {
      if (dashboardRef.current?.id !== currentMenu?.id) {
        return;
      }
      const { guest_token, workspace_region, workspace_name } = presetInfo || {};
      if (!guest_token) {
        setState({
          noReport: true,
        });
        return;
      }
      setState({
        loading: false
      });
      // 打点
      const { id = '', name_en: nameEn } = currentMenu || {};
      const logObj = {
        pageId: id,
        menuId: id,
        pageName: nameEn,
        extInfo: nameEn,
        pagePath: getPathFromDashboard(currentMenu),
        uid: gameCode,
        typeId: LOG_SYSTEM_TYPE,
      };
      buriedPoint(logObj);
      let fetchNum = 0;   
      const dashboardUiConfig= extInfo ? {
        hideTitle: true,
        hideTab: true,
        hideChartControls: false,
        filters:
          strToObject(extInfo)
      } : {
        hideTitle: true,
        hideTab: true,
        hideChartControls: false,
      }
      embedDashboard({
        id: rawPresetId, // given by the Superset embedding UI
        supersetDomain: `https://${workspace_name}.${workspace_region}.app.preset.io`,
        mountPoint: document.getElementById('report-iframe-wrap') as HTMLElement, // any html element that can contain an iframe
        fetchGuestToken: () => {
          fetchNum++;
          if (fetchNum === 1) {
            return guest_token;
          }
          return getPresetInfo(`${gameCode}/${presetId}`).then(data => {
            return data?.guest_token || '';
          }, () => {
            return '';
          })
        },
        dashboardUiConfig, // dashboard UI config: hideTitle, hideTab, hideChartControls (optional)
      }).then(preset => {
        presetRef.current = preset;
      });
    }, () => {
      if (dashboardRef.current?.id !== currentMenu?.id) {
        return;
      }
      presetRef.current && presetRef.current?.unmount();
      setState({
        noReport: true
      });
    }).catch(e=>{
      console.log(e)
    });
  }

  const errorInfo = useMemo(() => {
    // 路径中无reportid
    if (!reportId) {
      return <Permission type="error" textCN="未获取到报表信息" />
    }
    // 无currentMenu，或者currentMenu不是tableau，或者currentMenu跟路径中的reportId不匹配，说明currentMenu 未更新，等待currentMenu更新，此时执行loading等待
    if (!currentMenu || getDashboardType(currentMenu) !== PAGE_TYPE_PRESET || !checkReportIdWithName(reportId, currentMenu?.name_en) || reportInfo.loading) {
      return <Loading />;
    }
    // 路径中无reportid
    if (reportInfo.noReport) {
      return <Permission type="error" textCN="未获取到报表信息" />
    }
    return null;
  }, [currentMenu, reportId, reportInfo]);

  useEffect(() => {
    openPresetReport();
  }, [reportId, currentMenu]);

  return (
    <>
      {/* <div className='dtb-db-iframe-wrap' id="report-iframe-wrap">{errorInfo}</div> */}
      {/* 优化如上代码，避免当getPresetInfo请求失败时presetRef.current?.unmount()报错 页面白屏 */}
      { errorInfo && <div className='dtb-db-iframe-wrap'>{errorInfo}</div>} 
      <div className='dtb-db-iframe-wrap' id="report-iframe-wrap" style={{display:errorInfo ? 'none' : 'block'}} />
      <GuideTableau/>
    </>
  );
};
